import {
  UserCircleIcon,
  CogIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  ShieldCheckIcon,
  ExclamationTriangleIcon,
  BuildingStorefrontIcon,
  BriefcaseIcon,
  ChatBubbleLeftRightIcon,
  VideoCameraIcon,
  MegaphoneIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';

export const helpTopics = [
  {
    id: 'account-settings',
    title: 'Configuración de la cuenta',
    description: 'Gestiona tu perfil, contraseña y notificaciones.',
    icon: UserCircleIcon,
    questions: [
      {
        id: 'q1-1',
        question: '¿Cómo puedo cambiar mi nombre de usuario o mi foto de perfil?',
        answer: 'Puedes actualizar tu información personal, incluyendo tu nombre de usuario, biografía y fotos, desde la sección "Editar Perfil" en tu página de perfil.',
      },
      {
        id: 'q1-2',
        question: '¿Cómo cambio mi contraseña?',
        answer: 'Para cambiar tu contraseña, ve a "Editar Perfil", selecciona la pestaña "Seguridad" y sigue las instrucciones. Te recomendamos usar una contraseña única y segura.',
      },
      {
        id: 'q1-3',
        question: '¿Cómo puedo eliminar mi cuenta?',
        answer: 'La opción para solicitar la eliminación permanente de tu cuenta se encuentra en la pestaña de "Seguridad" dentro de "Editar Perfil". Ten en cuenta que esta acción es irreversible.',
      },
    ],
  },
  {
    id: 'agora-pay',
    title: 'Agora Pay y Cartera',
    description: 'Aprende a comprar, enviar y retirar monedas.',
    icon: CurrencyDollarIcon,
    questions: [
      {
        id: 'q2-1',
        question: '¿Qué son las monedas y para qué sirven?',
        answer: 'Las monedas son la moneda virtual de nuestra plataforma. Puedes usarlas para dar propinas a creadores, comprar productos destacados o acceder a funciones exclusivas.',
      },
      {
        id: 'q2-2',
        question: '¿Cómo compro monedas?',
        answer: 'Puedes comprar paquetes de monedas de forma segura usando tu tarjeta de crédito a través de Stripe. Ve a tu perfil y busca la pestaña "Cartera" o "Agora Pay".',
      },
      {
        id: 'q2-3',
        question: '¿Puedo retirar mis monedas como dinero real?',
        answer: 'Sí. Si has acumulado suficientes monedas, puedes solicitar un retiro a tu cuenta de PayPal. El valor de conversión se mostrará en la sección de retiros de tu cartera.',
      },
    ],
  },
  {
    id: 'privacy-security',
    title: 'Privacidad y Seguridad',
    description: 'Controla quién ve tu contenido y mantén tu cuenta segura.',
    icon: ShieldCheckIcon,
    questions: [
      {
        id: 'q3-1',
        question: '¿Cómo controlo la privacidad de mis publicaciones?',
        answer: 'Al crear una publicación, puedes elegir quién puede verla: "Público" (todos), "Amigos" (solo tus conexiones aceptadas) o "Solo yo".',
      },
      {
        id: 'q3-2',
        question: '¿Qué es la autenticación de dos factores (2FA)?',
        answer: 'Es una capa extra de seguridad. Si la activas, además de tu contraseña, necesitarás un código de una app de autenticación para iniciar sesión. Puedes configurarla en "Seguridad".',
      },
    ],
  },
  {
    id: 'stores-companies',
    title: 'Tiendas y Empresas',
    description: 'Crea y gestiona la página de tu negocio.',
    icon: BuildingStorefrontIcon,
    questions: [
      {
        id: 'q4-1',
        question: '¿Cómo creo una página de empresa o una tienda?',
        answer: 'En el menú principal, busca la opción "Crear Página" y elige si deseas crear una página de empresa (para promocionar tu marca) o una tienda (para vender productos).',
      },
      {
        id: 'q4-2',
        question: '¿Cómo añado productos a mi tienda?',
        answer: 'Una vez creada tu tienda, tendrás acceso a un panel de gestión donde podrás añadir productos, establecer precios, subir imágenes y gestionar tu inventario.',
      },
    ],
  },
  {
    id: 'jobs',
    title: 'Empleos',
    description: 'Publica ofertas y encuentra candidatos, o busca tu próximo trabajo.',
    icon: BriefcaseIcon,
    questions: [
      {
        id: 'q5-1',
        question: '¿Cómo publico una oferta de empleo?',
        answer: 'Si tienes una página de empresa, puedes acceder a la sección "Empleos" y crear una nueva oferta de trabajo, especificando los detalles del puesto y los requisitos.',
      },
      {
        id: 'q5-2',
        question: '¿Cómo creo mi perfil profesional para aplicar a trabajos?',
        answer: 'En tu perfil de usuario, puedes completar tu "Perfil Profesional", añadiendo tu experiencia laboral, educación y habilidades. Esto funcionará como tu CV digital en la plataforma.',
      },
    ],
  },
  // ... aquí se podrían añadir más categorías como Chat, Streaming, Anuncios, etc.
];